module.exports = __webpack_public_path__ + "img/DSC_0046.a0fc5c16.jpg";